
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Cookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { BindReportGrid, ReverseFormatDate, exportToExcel, formatDate, setFocus, setTitle } from "../Common/Common";
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { getCommonData } from '../Common/CommanServices';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";
import Loader from '../Layout/Loader';

const OrderEntryReport = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode')
    const [isUpdate, setIsUpdate] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [SalesPersonPre, setSalesPersonPre] = useState('')
    const [customerData, setCustomerData] = useState([]);
    const [salesPerson, setSalesPerson] = useState([]);
    const [tableData, setTableData] = useState({})
    const [ItemNoData, setItemNoData] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [MenuText, setMenuText] = useState("Order Entry Report");
    const [ReportTypeDropDown] = useState([
        {
            ReportTypeCode: 'Summarised',
            ReportType: 'Summarised'
        },
        {
            ReportTypeCode: 'DETAIL',
            ReportType: 'DETAIL'
        },
    ]);

    const [FilterData, setFilterData] = useState({
        PageIndex: "1",
        ReportType: ReportTypeDropDown[0].ReportTypeCode,
        OrderNo: "",
        Customer: "",
        ContactPerson: "",
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        OrderDateFrom: "",
        OrderDateTo: "",
        DeliveryDateFrom: "",
        DeliveryDateTo: "",
        ItemNo: "",
    });

    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }

    useEffect(() => {
        setTitle('OrderEntryReport', setOpen);
        setFocus('txtOrderNo');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    //useEffect(() => {
    //    getOrderEntryData();
    //}, [FilterData.PageIndex, isUpdate]);

 
    const getOrderEntryData = async (Type = 'S',PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Report/ShowExOrderEntryReport`, { ...data }, (res) => {
         
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                       exportToExcel(res.Data, 'OrderReport');
                    }
                }
            }
            else if (res.Status === 'EXPIRED') {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]
                    })
            }
            setIsLoading(false)
        })
    }

    const handleChange1 = (event, value) => {
        getOrderEntryData("S",value);
    };

    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                OrderNo: "",
                ReportType: ReportTypeDropDown[0].ReportTypeCode,
                Customer: "",
                ContactPerson: "",
                SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
                OrderDateFrom: "",
                OrderDateTo: "",
                DeliveryDateFrom: "",
                DeliveryDateTo: "",
                ItemNo: "",
            }
        );

        setTableData(
            {
                totalRecord: 0,
                gridData: [{
                }]
            }
        );
        setFocus('txtOrderNo');
        setIsUpdate(!isUpdate)
    }

    const searchHandle = async () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        getOrderEntryData();
    }

    const handleDownloadExcel = async () => {
        getOrderEntryData('E');
    }

    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };

    const getCustomer = () => {
        setCustomerData([])
        let temp = {
            Type: "GetCustomer",
            Prefix: "",
            ContextKey: SalesPersonPre.split(':')[0].trim(),
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CustomerDatalist = res.autoCompleteData || [];
                setCustomerData(CustomerDatalist);
            } else {
                setCustomerData([]);
            }
        });
    }
    const getItemNo = () => {
        setItemNoData([])
        let temp = {
            Type: "GetItemNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let itemData = res.autoCompleteData || [];
                setItemNoData(itemData);
            } else {
                setItemNoData([]);
            }
        });
    }
    let SalesPersonArr = []
    for (let i = 0; i < salesPerson.length; i++) {
        let mydata = salesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };

    let CustomerArr = []
    for (let i = 0; i < customerData.length; i++) {
        let mydata = customerData[i]?.values
        CustomerArr.push(mydata)
    };
    let ItemNoArr = []
    for (let i = 0; i < ItemNoData.length; i++) {
        let mydata = ItemNoData[i]?.values
        ItemNoArr.push(mydata)
    };

    useEffect(() => {
        if (FilterData.OrderDateFrom) {
            const fromDateObj = new Date(FilterData.OrderDateFrom);
            const toDateObj = new Date(FilterData.OrderDateTo);

            if (
                !FilterData.OrderDateTo ||
                toDateObj <= fromDateObj
            ) {
                const nextDay = new Date(fromDateObj);
                nextDay.setDate(fromDateObj.getDate() + 1);

                const formattedNextDay = formatDate(nextDay);

                setFilterData(prev => ({
                    ...prev,
                    OrderDateTo: formattedNextDay
                }));
            }
        }
    }, [FilterData.OrderDateFrom]);


    useEffect(() => {
        if (FilterData.DeliveryDateFrom) {
            const fromDateObj = new Date(FilterData.DeliveryDateFrom);
            const toDateObj = new Date(FilterData.DeliveryDateTo);

            if (
                !FilterData.DeliveryDateTo ||
                toDateObj <= fromDateObj
            ) {
                const nextDay = new Date(fromDateObj);
                nextDay.setDate(fromDateObj.getDate() + 1);

                const formattedNextDay = formatDate(nextDay);

                setFilterData(prev => ({
                    ...prev,
                    DeliveryDateTo: formattedNextDay
                }));
            }
        }
    }, [FilterData.DeliveryDateFrom]);
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Order No.</label>
                                            <input
                                                maxLength="50"
                                                id='txtOrderNo'
                                                type="text"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtCustomer')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Order No'
                                                value={FilterData.OrderNo}
                                                onChange={(e) => {
                                                    setFilterData({ ...FilterData, OrderNo: e.target.value.toUpperCase() })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtSalesPerson") };
                                                }}
                                                label='Customer'
                                                placeholder="Customer "
                                                maxLength='50'
                                                options={CustomerArr}
                                                id='txtCustomer'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getCustomer()}
                                                inputValue={FilterData.Customer ? FilterData.Customer : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('Customer', newInputValue)

                                                }}
                                            />
                                        </div>

                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtContactPerson") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={FilterData.SalesPerson ? FilterData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('SalesPerson', newInputValue)
                                                    setSalesPersonPre(newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Contact Person</label>
                                            <input
                                                id='txtContactPerson'
                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtOrderDateFrom')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Contact Person'
                                                value={FilterData.ContactPerson}
                                                onChange={(e) => {
                                                    setFilterData({ ...FilterData, ContactPerson: e.target.value })
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Order Date</label>
                                            <div className="row">
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.OrderDateFrom)}
                                                        id='txtOrderDateFrom'
                                                        className="form-control"
                                                        placeholderText='From Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, OrderDateFrom: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtOrderDateTo')
                                                            };
                                                        }}
                                                        maxDate={new Date()}
                                                    /></div>
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.OrderDateTo) || null}
                                                        id='txtOrderDateTo'
                                                        className="form-control"
                                                        placeholderText='To Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, OrderDateTo: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtDeliveryDateFrom')
                                                            };
                                                        }}
                                                        minDate={new Date(FilterData.OrderDateFrom) || null}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Delivery Date</label>
                                            <div className="row">
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.DeliveryDateFrom) || null}
                                                        id='txtDeliveryDateFrom'
                                                        className="form-control"
                                                        placeholderText='From Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({
                                                                ...FilterData,
                                                                DeliveryDateFrom: formatDate(date),
                                                            })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtDeliveryDateTo')
                                                            };
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.DeliveryDateTo)}
                                                        id='txtDeliveryDateTo'
                                                        className="form-control"
                                                        placeholderText='To Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({
                                                                ...FilterData,
                                                                DeliveryDateTo: formatDate(date),
                                                            })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtReportType')
                                                            };
                                                        }}
                                                        minDate={new Date(FilterData.DeliveryDateFrom) || null}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Report Type</label>
                                            <select
                                                id='txtReportType'
                                                className="form-control"
                                                value={FilterData.ReportType}
                                                onChange={(e) => {
                                                    setFilterData({ ...FilterData, ReportType: e.target.value })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        if (FilterData.ReportType === 'DETAIL') {
                                                            setFocus('txtItemNo');
                                                        } else {
                                                            setFocus('btnSearch')
                                                        }
                                                    };
                                                }}
                                            >
                                                {
                                                    ReportTypeDropDown?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.ReportTypeCode}>{item.ReportType}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    {FilterData?.ReportType === 'DETAIL' ?
                                        <>
                                            <div className="col-lg-3 col-md-4 col-sm-6">
                                                <div className="fields">
                                                 
                                                    <AutoCompleteBox                                                       
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') { setFocus("btnSearch") };
                                                        }}
                                                        label='Item No'
                                                        placeholder="Item No"
                                                        maxLength='50'
                                                        options={ItemNoArr}
                                                        id='txtItemNo'
                                                        required={true}
                                                        ignore_common={true}
                                                        onFocus={() => getItemNo()}
                                                        inputValue={FilterData.ItemNo ? FilterData.ItemNo : ''}
                                                        onInputChange={(event, newInputValue) => {
                                                            HandleChange('ItemNo', newInputValue)

                                                        }}

                                                    />
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <></>
                                    }

                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} currentPageNo={currentPageNo} handleChange1={handleChange1} />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </main>
    )
}
export default OrderEntryReport